module.exports = __webpack_public_path__ + "static/img/color.c900b5b4.jpg";